module.exports = __webpack_public_path__ + "static/bold-4b29107983583369b7ff6c6af15aae31.woff2";